import { OrganizerSharedLayoutModalConfigInterface } from '~/organizer/shared/components/shared/layouts/funnel/interfaces/modal-config.interface';

export const organizerActivityPlanningLeaveModalConfig: OrganizerSharedLayoutModalConfigInterface =
  {
    headerKey: 'activity_planning.leave_modal.header',
    labelKey: 'activity_planning.leave_modal.label',
    redirectRouteName: 'organizer.planning.planning',
  };
